import { useGet } from './useFetch'
import { useAuth } from './useAuth'
import { ApiResponse } from '@magnetar/admin-api-interfaces'

export interface AdScheduleTemplateSlotItem {
  item_id: number
  slot_id: number
  advertisement_id: number
  order: number
  play_duration: number
  created_at: string
  updated_at: string
  is_active: boolean
  advertisement: {
    advertisement_id: number
    supplier_id: number
    title?: string
    description?: string
    created_at: string
    is_active: boolean
    media: Array<{
      ad_media_id: number
      advertisement_id: number
      file_uuid: string
      media_order: number
      play_duration_ms?: number
      created_at: string
      is_active: boolean
    }>
  }
}

export interface AdScheduleTemplateSlot {
  slot_id: number
  template_id: number
  slot_number: number
  slot_name?: string
  total_duration: number
  play_minute: number
  created_at: string
  updated_at: string
  is_active: boolean
  slot_items: AdScheduleTemplateSlotItem[]
}

export interface AdScheduleTemplate {
  template_id: number
  template_name: string
  description?: string
  provider_id?: number | null
  created_by?: number
  created_at: string
  updated_at: string
  is_active: boolean
  duration_limit_enabled: boolean
  slots: AdScheduleTemplateSlot[]
}

interface UseAdScheduleTemplatesParams {
  includeInactive?: boolean
  providerId?: number
}

export function useAdScheduleTemplates(params?: UseAdScheduleTemplatesParams) {
  const { token } = useAuth()

  // Build query string
  const queryParams = new URLSearchParams()
  if (params?.includeInactive) queryParams.set('includeInactive', 'true')
  if (params?.providerId) queryParams.set('providerId', String(params.providerId))
  const queryString = queryParams.toString() ? `?${queryParams.toString()}` : ''

  const { data, error, mutate } = useGet<ApiResponse<AdScheduleTemplate[]>>(
    token ? `/api/ad-schedule-templates${queryString}` : null,
    undefined,
    token ?? '',
  )

  return {
    templates: data?.data || [],
    isLoading: !error && !data,
    isError: error,
    mutate,
  }
}
